import React, {} from "react";

import SpinnerDiv from "ui/SpinnerDiv";

import './TableTeachers.scss'
import {
  defaultPaginationOptions,
  defaultTableHeaderStyles,
} from "root/School/BaseTableComponents";
import PassportTable, {xlateBootstrapTableColumns} from "root/Tables/PassportTable";
import {customHeaderStyle, defaultTopLeftCellStyle, defaultTopRightCellStyle} from "root/Tables/BaseTableComponents";

const TableTeachers= (props) =>
{
  const onClickEdit = ( school_id ) =>
  {
    props.clickHandler (school_id, 'edit', props.onDialogClosed );
  }

  const headerStyle = customHeaderStyle.bind(null, {
    default: defaultTableHeaderStyles,
    firstname: {borderRadius: defaultTopLeftCellStyle, width: "18vw"},
    email: {borderRadius: defaultTopRightCellStyle, textAlign: 'left'}
  });

  const getColumns = () => {
    const columns = [
      {
        dataField: "firstname",
        text: "First Name",
        sort: true,
        headerStyle: headerStyle
      },
      {
        dataField: "surname",
        text: "Surame",
        sort: true,
        headerStyle: headerStyle
      },
      {
        dataField: "email",
        text: "Email Address",
        sort: true,
        headerStyle: headerStyle
      },
        /*
      {
        dataField: "view",
        text: "",
        formatter: linkFormatter,
        headerStyle: leftHeaderStyle
      } */
    ];

    return columns;
  };

  const translations = xlateBootstrapTableColumns(getColumns());

  const columns = React.useMemo(() => translations, []);

  const tableContent = () =>
  {
    return <PassportTable data={props.data} columns={columns} pagination={defaultPaginationOptions}/>

  }

  return props.loading === true ? <SpinnerDiv/> : tableContent();
};

export default TableTeachers;
